/**
 * Steady Hands: a stat grant, and the simplest thing a perk can be.
 *
 * The seed instance for the `statGrants` channel. Perception goes through `statDeltas` and
 * therefore through `statsWithLoadout`, which clamps, so this and a helmet cannot between them push
 * anyone past the ceiling.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const STEADY_HANDS = {
  id: 'steadyHands',
  branch: 'gunplay',
  tier: 1,
  title: 'Steady Hands',
  blurb: 'Marksmanship correspondence course, completed at your own pace. Perception up.',
  maxRanks: 2,
  minLevel: 3,
  requires: [],
  statGrants: { perception: 1 },
  effects: [],
  damageModifiers: [],
} as const satisfies Perk;
